/**
 * Desconto Progressivo (item 8 do pedido de 19/10) na configuração do Master (Normal e App Driver).
 *
 * Os campos da tela guardam o texto digitado (como os demais NumField); ao salvar eles vão como
 * número, e vazio vai como null (NULL no banco = desligado/sem valor). Ligado exige mínimo e
 * desconto maiores que zero, para não subir uma regra que nunca vale ou que vale para qualquer valor.
 * Sem teto: vale o ¢/L lançado pelo Master (decisão do cliente, 24/10/2026).
 */
const CAMPOS_NUM = ["progressivo_valor_minimo_reais", "progressivo_desconto_centavos"];

function numeroOuNulo(v) {
  if (v == null) return null;
  const txt = String(v).trim().replace(",", ".");
  if (txt === "") return null;
  const n = Number(txt);
  return Number.isFinite(n) ? n : NaN;
}

export function normalizaProgressivo(cfg) {
  const valores = { progressivo_ativo: !!cfg?.progressivo_ativo };
  for (const k of CAMPOS_NUM) valores[k] = numeroOuNulo(cfg?.[k]);
  if (CAMPOS_NUM.some((k) => Number.isNaN(valores[k]) || (valores[k] != null && valores[k] < 0))) {
    return { erro: "Desconto Progressivo: informe números válidos (valor mínimo em R$ e desconto em ¢/L).", valores };
  }
  if (valores.progressivo_ativo && !(valores.progressivo_valor_minimo_reais > 0 && valores.progressivo_desconto_centavos > 0)) {
    return { erro: "Desconto Progressivo ligado: informe o valor mínimo (R$) e o desconto (¢/L), ambos maiores que zero.", valores };
  }
  return { erro: null, valores };
}
